import { IAnnouncement } from "@/modules/dashboard/types";
import IIndexable from "@/utils/types/IIndexable";
import { Module, Mutation, VuexModule, config } from "vuex-module-decorators";
import { IRate } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class SellModule extends VuexModule {
  rates: IRate[] | null = null;
  announcement: IAnnouncement | null = null;

  @Mutation
  setRates(rates: IRate[]) {
    this.rates = rates;
  }

  @Mutation
  setAnnouncement(announcement: IAnnouncement | null) {
    this.announcement = announcement;
  }

  @Mutation
  clear() {
    this.rates = null;
  }
}
